<div class="tw-flex tw-flex-col tw-basis-full tw-items-stretch bg-white">

    <section class="tw-flex tw-flex-col tw-basis-full">
        <p-tabView class="custom-tabview no-panels" (onChange)="this.setEntity($event)" [(activeIndex)]="service.selectedEntityIndex">
            <p-tabPanel *ngIf="this.userPermissionService.effectivePermissions[this.PermissionDictionary.Tenant_SettingsEditor] | async" header="">
                <ng-template pTemplate="header">
                    <em class="fal fa-gears tw-pr-2"></em>
                    <span>Settings Editor</span>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="">
                <ng-template pTemplate="header">
                    <em class="fal fa-user-helmet-safety tw-pr-2"></em>
                    <span>Products</span>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="">
                <ng-template pTemplate="header">
                    <em class="fal fa-command tw-pr-2"></em>
                    <span>Campaigns</span>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="" *ngIf = "this.service.userHasIngestionPermissions">
                <ng-template pTemplate="header">
                    <em class="fal fa-upload tw-pr-2"></em>
                    <span>Ingestion</span>
                </ng-template>
            </p-tabPanel>
        </p-tabView>


        <section class="tw-flex tw-flex-col tw-basis-full">
            <ng-container [ngSwitch]="true">
                <app-settings-editor *ngSwitchCase="service.isSettingsCurrentEntity" class="tw-w-full tw-h-full"></app-settings-editor>

                <app-campaigns *ngSwitchCase="service.isCampaignCurrentEntity" class="tw-w-full tw-h-full"></app-campaigns>

                <app-ingestion *ngSwitchCase="service.isIngestionCurrentEntity" class="tw-w-full tw-h-full"></app-ingestion>

            
            </ng-container>
        </section>
    </section>


</div>
